import { Injectable } from '@angular/core';
import { CampaignService } from '../campaign.service';

/* RxJs */
import { Observable, of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';

/* NgRx */
import * as createdByMeCampaignActions from './created-by-me-campaign.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

@Injectable()
export class CreatedByMeCampaignEffects {
    constructor(private _campaignService: CampaignService,
        private _actions$: Actions) { }

    @Effect()
    loadMyDraftCampaignSummaries$: Observable<Action> = this._actions$.pipe(
        ofType(createdByMeCampaignActions.CreatedByMeCampaignActionTypes.loadCampaigns),
        map((action: createdByMeCampaignActions.LoadCampaigns) => action.payload),
        mergeMap((requestInfo) =>
            this._campaignService.getMyDraftCampaigns(requestInfo.pagination.index, requestInfo.pagination.size,
                requestInfo.sorting.fieldName, requestInfo.sorting.direction).pipe(
                map(campaigns => (new createdByMeCampaignActions.LoadCampaignsSuccess(campaigns))),
                catchError(() => of(new createdByMeCampaignActions.LoadCampaignsFail('Error loading my draft campaigns')))
            )
        )
    );
}
